/**
 * Authentication configuration constants
 */

export const AUTH_CONFIG = {
  // Password requirements
  PASSWORD_MIN_LENGTH: 8,
  
  // Email settings
  EMAIL_CONFIRMATION_REQUIRED: true,
  
  // Rate limiting (handled by Supabase)
  MAX_LOGIN_ATTEMPTS: 5, // Per hour (Supabase default)
  PASSWORD_RESET_COOLDOWN: 60, // seconds
  
  // Session settings
  SESSION_STORAGE_KEY: 'sb-auth-token',
  REDIRECT_STORAGE_KEY: 'redirectTo',
  
  // OAuth settings
  OAUTH_REDIRECT_URL: `${window.location.origin}/login`,
} as const;

export const AUTH_MESSAGES = {
  // Success messages
  REGISTRATION_SUCCESS: 'Account created successfully! Please check your email to verify your account.',
  PASSWORD_RESET_SENT: 'Password reset instructions have been sent to your email.',
  EMAIL_VERIFIED: 'Your email has been verified successfully!',
  PASSWORD_UPDATED: 'Your password has been updated successfully.',
  
  // Error messages
  REGISTRATION_FAILED: 'Failed to create account. Please try again.',
  LOGIN_FAILED: 'Failed to sign in. Please check your credentials.',
  PASSWORD_RESET_FAILED: 'Failed to send password reset email. Please try again.',
  EMAIL_VERIFICATION_FAILED: 'Failed to verify email. Please try again.',
  ACCOUNT_NOT_VERIFIED: 'Please verify your email before signing in.',
  
  // General messages
  AUTH_REQUIRED: 'You must be signed in to access this page.',
  LOADING: 'Loading...',
  PROCESSING: 'Processing...',
} as const;

export const AUTH_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  PROFILE: '/profile',
  PASSWORD_RESET: '/reset-password',
  EMAIL_VERIFY: '/verify-email',
  HOME: '/',
  DASHBOARD: '/invoice_processor',
  PDF_PROCESSOR: '/invoice_processor/pdf',
} as const;

export const AUTH_TYPES = {
  EMAIL: 'email',
  GOOGLE: 'google',
} as const;

export type AuthType = typeof AUTH_TYPES[keyof typeof AUTH_TYPES]; 